import { api } from '@ohif/core';

/**
 * @param {unknown} patient
 * @param {unknown} project
 */
export async function generateTemporalToken(patient, project) {
  const path = '/tokens/generate-temporal-token';

  console.log('Fetching token validation from API:', path);

  const body = {
    patient_id: patient,
    project_id: project,
    viewer: '3D Viewer',
  };

  try {
    const response = await api.post(path, body);

    return response.data.ticket;
  } catch (error) {
    console.error(
      'Error generating temporal token:',
      error.response?.data?.detail || error.message
    );
  }
}
